import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { currentCategoryFAQPromoTextSelector } from '../../../../redux/product-listing/product-listing.selectors';
import { WeMadeThisComponent } from './we-made-this';
const mapStateToProps = createStructuredSelector({
  text: currentCategoryFAQPromoTextSelector
});
export const WeMadeThis = connect(mapStateToProps)(WeMadeThisComponent);